<template>
  <div class="input__selected-items--wrap" 
    :class="{'form-style' : formStyle}">
        <span 
            v-for="(listItem, index) in Array.isArray(this.value) ? this.value : new Array(this.value)"
            :key=index
            class="input__selected-items" 
            :class="{ 'form-style': formStyle }"
            @click="removeSelectedItem(listItem)"
            >
            <span 
              class="input__selected-item"
            >
            {{ getLabel(listItem) }}</span>
            <rp-sprite class="input__selected-item-icon" name="close" />
        </span>
    </div>

</template>

<script>
import Sprite from '../../../../components/ui/Sprite'

export default {
    components: {
    'rp-sprite': Sprite,
  },

    props: {
      value: [Object, Array, String],
      dataModel: [Object, Array, String],
      formStyle: Boolean
    },

    methods: {
        getLabel(listItem) {
            return this.$parent.getLabel(listItem)
        },
        removeSelectedItem(listItem) {
            this.$parent.removeSelectedItem(listItem)
        }
    }

}
</script>

<style lang="sass" scoped>
    @import '../../../../styles/base/variables'

    $global-padding__small: 4px

    .input__selected-items--wrap
      display: flex
      flex-direction: row
      flex-wrap: wrap

      &.form-style
        position: relative
        top: 10px

      .input__selected-items
        display: flex
        flex-direction: row
        align-items: center
        background: $color-primary
        width: fit-content
        padding: $global-padding__small
        border-radius: 5px
        margin: 5px
        cursor: pointer

        &.form-style
          margin: 5px 10px 5px 0

        .input__selected-item
          font-size: 9px
          color: white
          text-align: left

        .input__selected-item-icon
          max-width: 20px
          min-width: 20px
          max-height: 11px
          padding-left: $global-padding__small
          fill: white

</style>



// WEBPACK FOOTER //
// ../raypro_ui/src/components/ui/inputs/dropdown/Selected.vue